import * as angular from 'angular';
import * as template from './template.html';
import * as DesktopPoliciesPolicyHistoryCard from './desktop';
import * as MobilePoliciesPolicyHistoryCard from './mobile';

const module = angular.module('policies-policy-history-card', [
    DesktopPoliciesPolicyHistoryCard.module.name,
    MobilePoliciesPolicyHistoryCard.module.name
]);

module.component('policiesPolicyHistoryCard', {
    bindings: {
        policyInfo: '<',
        policyIndex: '<'
    },
    template: template
});

export { module };
